'use client';

import { ArrowRight } from 'phosphor-icons';
import { interpolateStringWithData } from 'utils';
import { c } from '../../../utils/tailwind-merge';
import { Link } from '../../atoms/Link';
import type { ProductListSeeMoreLinkProps } from './ProductListHeader.types';

export type { ProductListSeeMoreLinkProps };

export const ProductListSeeMoreLink = ({
  href,
  name,
  microcopy,
  className = '',
  testId = 'product-list-see-more-link',
}: ProductListSeeMoreLinkProps) => {
  const label = interpolateStringWithData(microcopy.seeMore, {
    name,
  });
  const ariaLabel = interpolateStringWithData(microcopy.seeMoreAria, {
    name,
  });

  return (
    <Link
      href={href}
      aria-label={ariaLabel}
      className={c(
        'flex items-center gap-1 text-[13px] font-medium text-blue hover:text-blue-hover',
        className
      )}
      data-test={testId}
    >
      {label}
      <ArrowRight
        size={20}
        weight="bold"
        className="lg:hidden"
        aria-hidden="true"
      />
      <ArrowRight
        size={20}
        weight="regular"
        className="hidden lg:inline"
        aria-hidden="true"
      />
    </Link>
  );
};

ProductListSeeMoreLink.displayName = 'ProductListSeeMoreLink';
